<template>
  <div class="modal_card">
    <div class="modal_form">
      <i @click="$emit('close-modal')" class="icon-close"></i>
      <h1>{{ modalInfo.header }}</h1>
      <form @submit.prevent="submit">
        <b-field
          label="Название группы:"
          type="is-info"
          :message="errors.first('name')"
          :class="errors.first('name') ? 'error' : ''"
        >
          <b-input
            name="name"
            type="text"
            placeholder="Название группы"
            v-model="newGroup.name"
            v-validate="{ required: true }"
          ></b-input>
        </b-field>
        <button class="add_user_button modal_button left_button" type="submit" :disabled="errors.items.length > 0">
          {{ modalInfo.button }}
        </button>
        <button type="button" @click="$emit('close-modal')" class="close_button modal_button right_button">
          Отмена
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    modalInfo: {
      default: () => {},
      type: Object,
    },
    newGroup: {
      default: () => {},
      type: Object,
    },
  },
  data() {
    return {
      isOpen: true,
    }
  },
  created() {
    this.updateDict();
  },
  methods: {
    submit() {
      this.$validator.validateAll().then((result) => {
        if (result) {
          this.$emit(this.modalInfo.action);
        }
      })
    },
    updateDict() {
      let dict = {
        custom: {},
      };
      dict.custom['name'] = {
        required: 'Поле не заполнено',
      };
      this.$validator.localize('ru', dict);
    },
  },
}
</script>
